<template>
  <div class="service-open">
    <div class="result-title">
      <div class="result-title-main">
        <span>生成</span>
        <span class="important-text">专属</span>
        <span>保证金预存账户</span>
      </div>
      <div class="result-title-second">
        用于保证金资金管理
      </div>
    </div>
    <div
      v-loading="loading"
      element-loading-text="正在生成，请稍后"
      element-loading-background="rgba(255, 255, 255, 1)"
    >
      <div class="account-card">
        <div class="account-no">
          <span class="account-no-main">
            {{ guaranteePreSave.subAccountNo }}
          </span>
          <span class="m-l-8">[保证金专属金预存账号]</span>
        </div>
        <div class="account-info">
          <div class="desc">
            <span class="desc-label">银行</span>
            <span class="desc-value">{{ guaranteePreSave.bank }}</span>
          </div>
          <div class="desc">
            <span class="desc-label">账户名称</span>
            <span class="desc-value">
              {{ guaranteePreSave.subAccountName }}
            </span>
          </div>
        </div>
        <div class="account-tip">
          <span>请线下向</span>
          <span class="important-text">保证金预存账号</span>
          <span>打款预存，企业保证金额度=预存金额</span>
        </div>
      </div>
      <div class="result-action m-t-42">
        <el-button class="open-button" type="primary" @click="toPreSaveHome">
          欢迎体验
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

/**
 * 保证金预存开通结果
 */
export default {
  name: 'GuaranteePreSaveOpenResult',

  data() {
    return {
      loading: false
    }
  },

  computed: {
    ...mapState('finance', ['guaranteePreSave'])
  },

  methods: {
    /**
     * 跳转至保证金预存功能页面
     */
    toPreSaveHome() {
      this.$router.replace({
        name: 'GuaranteePreSave'
      })
    },

    getPreSaveAccount() {
      this.$store.dispatch('finance/getGuaranteePreSave').then(() => {
        setTimeout(() => {
          this.loading = Boolean(!this.guaranteePreSave.subAccountNo)
        }, 3000)
      })
    }
  }
}
</script>

<style scoped lang="scss">
.service-open {
  width: 100%;
  text-align: center;
  margin: 44px 0;

  ::v-deep .open-button.el-button {
    width: 232px;
    height: 54px;
    border-radius: 27px;
    font-size: 20px;
  }

  .result-title {
    margin-bottom: 44px;

    .result-title-main {
      color: $text-color;
      font-size: 0;

      span {
        font-size: 24px;
      }
    }

    .result-title-second {
      color: $second-text-color;
      font-size: 20px;
      margin-top: 22px;
    }
  }

  .account-card {
    width: 70%;
    background: $primary-fifth-color;
    padding: 38px;
    margin: 0 auto;

    .account-no {
      color: $text-color;
      font-size: 16px;
      display: flex;
      align-items: center;
      justify-content: center;

      .account-no-main {
        font-size: 36px;
        @include text-bold;
      }
    }

    .account-info {
      width: 500px;
      display: flex;
      align-items: center;
      justify-content: space-evenly;
      margin: 0 auto;
      margin-top: 32px;

      .desc {
        .desc-label {
          color: $second-text-color;

          &::after {
            content: '：';
          }
        }

        .desc-value {
          color: $text-color;
          @include text-bold;
        }
      }
    }

    .account-tip {
      margin-top: 46px;
      font-size: 16px;
      color: $second-text-color;
    }
  }
}

.important-text {
  color: #e89529;
}
</style>
